// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===========================
   Course Payments Overview Page
=========================== */

.overview-container {
  padding-top: 2rem;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  background: linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%);
  min-height: 100vh;
  font-family: "Inter", sans-serif;
}

.dashboard-title {
  font-weight: 800;
  font-size: 2rem;
  background: linear-gradient(90deg, #6366F1, #8B5CF6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* Inputs */
.glass-input {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(8px);
  border-radius: 0.7rem;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.glass-input:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
  outline: none;
}

/* Cards */
.summary-card {
  transition: all 0.35s ease;
  border: none;
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  box-shadow: 0 8px 25px rgba(99, 102, 241, 0.1);
}

.summary-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 32px rgba(99, 102, 241, 0.25);
}

.active-card {
  border: 2px solid #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.3);
}

/* Tables */
.table-modern thead {
  background-color: #f1f3f9;
  font-size: 0.9rem;
  text-transform: uppercase;
  color: #555;
}

.table-modern tbody tr:hover {
  background-color: #f8f9ff;
}

/* Misc */
.border-dashed {
  border: 2px dashed #e0e0e0;
}

.fade-in {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/MonthlyWisePaymentsStatistics.css"],"names":[],"mappings":"AAAA;;6BAE6B;;AAE7B;EACE,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,6DAA6D;EAC7D,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA,WAAW;AACX;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA,UAAU;AACV;EACE,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* ===========================\r\n   Course Payments Overview Page\r\n=========================== */\r\n\r\n.overview-container {\r\n  padding-top: 2rem;\r\n  padding-left: 2.5rem;\r\n  padding-right: 2.5rem;\r\n  background: linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%);\r\n  min-height: 100vh;\r\n  font-family: \"Inter\", sans-serif;\r\n}\r\n\r\n.dashboard-title {\r\n  font-weight: 800;\r\n  font-size: 2rem;\r\n  background: linear-gradient(90deg, #6366F1, #8B5CF6);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n}\r\n\r\n/* Inputs */\r\n.glass-input {\r\n  background: rgba(255, 255, 255, 0.9);\r\n  backdrop-filter: blur(8px);\r\n  border-radius: 0.7rem;\r\n  border: 1px solid #e5e7eb;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.glass-input:focus {\r\n  border-color: #6366f1;\r\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\r\n  outline: none;\r\n}\r\n\r\n/* Cards */\r\n.summary-card {\r\n  transition: all 0.35s ease;\r\n  border: none;\r\n  border-radius: 1rem;\r\n  background: rgba(255, 255, 255, 0.7);\r\n  backdrop-filter: blur(8px);\r\n  box-shadow: 0 8px 25px rgba(99, 102, 241, 0.1);\r\n}\r\n\r\n.summary-card:hover {\r\n  transform: translateY(-6px);\r\n  box-shadow: 0 12px 32px rgba(99, 102, 241, 0.25);\r\n}\r\n\r\n.active-card {\r\n  border: 2px solid #6366f1;\r\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.3);\r\n}\r\n\r\n/* Tables */\r\n.table-modern thead {\r\n  background-color: #f1f3f9;\r\n  font-size: 0.9rem;\r\n  text-transform: uppercase;\r\n  color: #555;\r\n}\r\n\r\n.table-modern tbody tr:hover {\r\n  background-color: #f8f9ff;\r\n}\r\n\r\n/* Misc */\r\n.border-dashed {\r\n  border: 2px dashed #e0e0e0;\r\n}\r\n\r\n.fade-in {\r\n  animation: fadeIn 0.5s ease-in-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
